// Pluralize a user-created label (e.g. a dimension type name) for display.
// Covers the common English rules — enough for short noun labels; not a full
// inflector (no irregulars like "person"/"people"). A multi-word name pluralizes
// only its last word ("Coach Type" → "Coach Types").
export const pluralize = (word: string): string => {
  if (word === "") return word;
  const head = word.slice(0, -1);
  const last = word.slice(-1).toLowerCase();
  const prevTwo = word.slice(-2).toLowerCase();

  // consonant + y → ies ("Country" → "Countries", but "Day" → "Days")
  if (last === "y" && !"aeiou".includes(prevTwo[0])) {
    return `${head}ies`;
  }
  // sibilant endings → es ("Class" → "Classes", "Bus" → "Buses", "Box" → "Boxes")
  if (["s", "x", "z"].includes(last) || ["ch", "sh"].includes(prevTwo)) {
    return `${word}es`;
  }
  return `${word}s`;
};
